/**
 * Format a number with thousand separators (Vietnamese style: dot-separated).
 * Example: 241000 → "241.000"
 */
export function formatPrice(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "";
  return num.toLocaleString("vi-VN");
}

/**
 * Format price with currency.
 * If price is 0, empty, or invalid, returns "Liên hệ" (or "Contact" for English).
 * Example: 241000 → "241.000 VND"
 *          0 → "Liên hệ"
 */
export function formatPriceVND(
  value: number | string | null | undefined,
  locale: string = "vi"
): string {
  if (value === null || value === undefined || value === "") {
    return locale === "en" ? "Contact" : "Liên hệ";
  }
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num) || num <= 0) {
    return locale === "en" ? "Contact" : "Liên hệ";
  }
  const formatted = formatPrice(num);
  return `${formatted} VND`;
}
